/* eslint-disable no-process-env */
export default {
  environment: process.env.NODE_ENV || 'local',
  port: process.env.PORT || 8080,
};
